var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUltimoStatus = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00004 15.1666C4.04671 15.1666 0.833374 11.9533 0.833374 7.99998C0.833374 4.04665 4.04671 0.833313 8.00004 0.833313C11.9534 0.833313 15.1667 4.04665 15.1667 7.99998C15.1667 11.9533 11.9534 15.1666 8.00004 15.1666ZM8.00004 1.83331C4.60004 1.83331 1.83337 4.59998 1.83337 7.99998C1.83337 11.4 4.60004 14.1666 8.00004 14.1666C11.4 14.1666 14.1667 11.4 14.1667 7.99998C14.1667 4.59998 11.4 1.83331 8.00004 1.83331Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4733 10.62C10.3867 10.62 10.3 10.6 10.22 10.5467L8.15334 9.31335C7.64001 9.00668 7.26001 8.33335 7.26001 7.74002V5.00668C7.26001 4.73335 7.48668 4.50668 7.76001 4.50668C8.03334 4.50668 8.26001 4.73335 8.26001 5.00668V7.74002C8.26001 7.98002 8.46001 8.33335 8.66668 8.45335L10.7333 9.68668C10.9733 9.82668 11.0467 10.1334 10.9067 10.3734C10.8067 10.5334 10.64 10.62 10.4733 10.62Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUltimoStatus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ultimo-status.ed091677.svg";
export { ForwardRef as ReactComponent };